/* import __COLOCATED_TEMPLATE__ from './level-header-action.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();